<template>
	<div v-loading="element_loading" element-loading-text="拼命加载中......" element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">

		<div class="title">
			<div id="notice">
				<h5>单据库存&nbsp;&nbsp;说明:</h5><br>
				<span class="red">1、查询关键字:仓库、物品名称</span><br>
				<span></span><br>
			</div>
		</div>
		<div class="content_edit">
			<pre-button @button-event="select_method" :pre_control="control" />
			<div class="content_btn">
				<div class="content_btn_item">
					<button @click="look_note">备注说明</button>
				</div>
			</div>
		</div>

		<!-- 动态查询区生成 -->
		<div class="content_edit">
			<div class="content_edit_item" v-for="(item,index) in parm_sel" :key="index">
				<!-- {{handleImportView(item)}} -->
				<component :is="NextTickName(item.type)" :inData="checkJson(item)" @com-event="refresh_view_sel">
				</component>

			</div>
		</div>

		<pre-table ref="file_table" @tab-event="refresh_data" :api_url="load_url" :pre_post="load_json"
			:pre_post_upd="upd_json">
			<!-- 设定标题  -->
			<template slot="tab_title">
				<tr>
					<th v-for="(t,index) in parm_th" :key="index">{{t.name}}</th>
					<!-- <th class="short0 cen">编辑</th> -->
				</tr>
			</template>
			<template slot="tab_tr" slot-scope="user">
				<tr v-bind:id="'m_' + user.item[1].val" @click="sel_row(user.item,'edit')">

					<td v-for="(d,index) in user.item" :key="index" v-on:mousemove="show_detaildata($event, d.val, '1')"
						v-on:mouseout="noshow_detaildata">
						{{d.val}}
					</td>
					<!-- <td class="short0 cen">
						<button @click="sel_row(user.item,'show')">编辑</button>
						<button @click="sel_row(user.item,'del')">删除</button>
					</td> -->
				</tr>
			</template>
			<!-- 构建新增模板 -->
			<template slot="tab_addorupdate">




			</template>
		</pre-table>

		<per-exceldown v-show="show_excel" @exceldown-event="build_exceldata" :title="'下载数据'"
			v-bind:pre_postjson="postjson1" :clicktype="'down1'">
			<template slot="tab_excelup_title">
				<tr>
					<th>ID</th>
					<th v-for="(t,index) in parm_th" :key="index">{{t.name}}</th>
				</tr>
			</template>
			<template slot="tab_excelup_tr" slot-scope="user">
				<tr @click="sel_row(user.item)">
					<td v-for="(d,index) in user.item" :key="index">{{d.val}}</td>
				</tr>
			</template>
		</per-exceldown>

		<!-- 文件预览部分 -->
		<!-- 预览 与 下载 start-->
		<!-- <input class="displayno" type="file" id="savefile" v-on:change="getFilePath" multiple="multiple" /> -->
		<input class="displayno" type="file" id="savefile" v-on:change="getFilePath" />

		<a id="downlink"></a>
		<a id="loodlink" target="_blank"></a>

		<!-- 明细数据提示 -->
		<div id="pre_detail_data" style="display:none;">
			<p v-for="(item, index) in detail_data" :key="index">
				{{ item.name }}={{ item.amount }}
			</p>
		</div>
		<div id="pre_msg_data" style="display:none;"></div>

	</div>
</template>

<script>
	/*
名称：通用多文件管理操作
日期：2021-05-26
作者：hj
目标：

	id int primary key identity(1,1),
	sheet_no	varchar(50) not null,	--比赛活动编号
	mode_type	varchar(20),	--宣传海报 1个(haibao)+证书模版 zhengshu-A,zhengshu-A,zhengshu-A,zhengshu-A,zhengshu-A, 1-多个 这里要分明细表
	f_name		nvarchar(100),
	f_src		varchar(300),	--
	f_type		varchar(10),	--宣传海报 1个+证书模版 1-多个 这里要分明细表
	f_size		int,	--
	upd_id		int,
	flag		char(1),
	sys_update_time datetime,	--最后更新时间

*/
	import api from '@/utils/type.js';
	import {
		Sel_page_and_length,
		Method_CommonLong
	} from '@/utils/loadhttpdata.js';

	// 文件操作辅助方法
	import {
		base_encode
	} from "@/utils/base64.js";
	import {
		GetShort,
		DeleteSpecialWord,
		BackSpecial,
		ChangeSpecial,
		GetRandom
	} from "@/utils/localstore.js";
	import {
		BrowserGet
	} from '@/utils/systemSelect.js';


	export default {
		name: "pre_tan_file",
		components: {
			"pre-button": () => import("../per_old/pre_btn_control.vue"),
			'per-exceldown': () => import("../auto/auto_excel_down.vue"),
			"pre-table": () => import("../auto/auto_view_table.vue")
		},
		data() {
			return {
				element_loading: false,

				row_id: '',
				sys_date: '',

				control: '',
				load_url: '',
				load_json: '',
				upd_json: '',
				nowpage: '1',
				page_length: 20, //add 2022-01-25 默认分页长度
				sheet_flag: '',

				// excel
				show_excel: false,
				postjson1: {},

				// 备注
				detail_data: '',
				max_row: [],

				sel_action: '',

				parm_sel: [], //查询结构
				parm: [], //参数结构
				parm_th: [], //标题
				kw1: '',
				kw2: '',
				kw3: '',
				kw4: '',
				kw5: '',

				//文件
				file_name: "",
				file_data: "",
				file_up: "",
				file_url: "",
				file_src: "",
				file_size: "",
				file_type: '',
				file_action: '',
				blockSize: '',
				file_backdata: '',
				p1: '',
				p2: '',
				p3: '',

				list_file: [],


			};
		},
		activated() {
			console.log('激活');
		},
		mounted() {
			console.log('加载');
			this.load_data();
		},
		methods: {
			NextTickName: function(key) {
				// console.log('key=' + key);
				return 'pre' + key;
			},
			checkJson: function(d) {
				let temp = '';
				temp = JSON.stringify(d)
				return temp;
			},
			refresh_view_sel: function(d) {
				// console.log('查询回传=', d);
				for (let i = 0; i < this.parm_sel.length; i++) {
					if (this.parm_sel[i].key == d.key) {
						this.parm_sel[i].val = d.val;
						break;
					}
				}
			},
			refresh_view_edit: function(d) {
				console.log(d);
				for (let i = 0; i < this.parm.length; i++) {
					if (this.parm[i].key == d.key) {
						this.parm[i].val = d.val;
						break;
					}
				}
			},
			check_is_pdf: function(res_url) {
				let is_pdf = false;
				if (/\.(pdf)$/.test(res_url.toLowerCase())) {
					is_pdf = true;
				}
				return is_pdf;
			},
			check_url: function(url) {
				let t = BackSpecial(url);
				// console.log(t);
				return t;
			},
			look_note: function() {
				//收缩区 收放设置
				this.show_note = this.show_note ? false : true;
				if (this.show_note) {
					$("#notice").slideDown("slow");
				} else {
					$("#notice").slideUp("slow");
				}
			},
			load_data: function() {
				// console.log(r);
				this.max_row = [];
				for (let i = 1; i < 10; i++) {
					let o = {};
					o.row = i;
					this.max_row.push(o);
				}

				this.control = 'tab_sheet_qty';
				this.sel_action = 'exp_store_car_tabstoresheetno';
				this.upd_action = '';
				this.api_url = api.http_method;

				this.title = '单据库存';

				this.parm_sel = [{
						"name": "仓库名称",
						"val": "",
						"key": "in_store",
						"type": "select",
						"class": "long2",
						"sel_action": "_base_storecar",
						"sel_name": ""
					},
					{
						"name": "物品编号",
						"val": "",
						"key": "item_no",
						"type": "text",
						"class": "long1",
					},
					{
						"name": "物品名称",
						"val": "",
						"key": "item_name",
						"type": "text",
						"class": "long1"
					},
					{
						"name": "车队",
						"val": "",
						"key": "team",
						"type": "select",
						"class": "long1",
						"sel_action": "_base_teamname",
						"sel_name": ""
					}
				]
				// sheet_no,sign_no,u_name,sex,u_phone,u_email,u_old,u_address,u_qq,
				//u_weixin,u_stu,u_College,profession,u_grade,note from tb_user_sign_up_all
				this.parm_th = [{
						"name": "序号"
					},
					{
						"name": "仓库"
					},
					{
						"name": "归属车队"
					},
					{
						"name": "业务单据"
					},
					{
						"name": "关联业务单据"
					},
					{
						"name": "物品编号"
					},
					{
						"name": "物品条码"
					},
					{
						"name": "物品名称"
					},
					{
						"name": "变更数量"
					},
					{
						"name": "入|出"
					},

					{
						"name": "备注"
					},
					{
						"name": "修改人"
					},
					{
						"name": "更新时间"
					}
				]


				this.parm = []


				// this.load_db_data();

			},
			select_method: function(type) {
				console.log(type);

				switch (type) {
					case 'sel':
						this.load_db_data();
						break;
					case 'new':
						this.data_clear();
						break;
					case 'exl_down':
						this.build_exceldata();
						break;
					case 'exl':
						this.build_exceldata();
						break;
					case 'filelook':
						this.fun_filelook();
						break;
					default:
						this.$message.error('错误:标识:' + type + ' 没有配置相应方法!');
						break;
				}
			},
			data_clear: function() {
				// console.log('清除 历史 参数。。。。');

				this.row_id = '';
				this.sys_date = '';
				// 文件名称、路径、储存 选择确定
				this.sheet_flag = '';
				this.sheet_no = '';

				this.file_name = '';
				this.file_url = '';
				this.file_src = '';
				this.file_up = '';

				for (let j = 0; j < this.parm.length; j++) {
					if (this.parm[j].type == 'select') {
						this.parm[j].val = '';
						this.parm[j].sel_name = '';
					} else {
						this.parm[j].val = '';
					}

				}

				for (let j = 0; j < this.parm_sel.length; j++) {
					if (typeof(this.parm_sel[j].type) != 'undefined' && this.parm_sel[j].type == 'select') {
						this.parm_sel[j].val = '';
						this.parm_sel[j].sel_name = '';
					} else {
						this.parm_sel[j].val = '';
					}

				}

				this.kw1 = '';
				this.kw2 = '';
				this.kw3 = '';
				this.kw4 = '';
				this.kw5 = '';
				this.kw6 = '';
				this.kw7 = '';
				this.kw8 = '';
				this.kw9 = '';
				this.kw10 = '';

				this.d_detail = [];
				console.log('33333333');
				// console.log('===END============')
			},
			load_db_data: function() {
				// console.log('全条件查询====');
				// console.log(this.parm_sel);
				for (let i = 0; i < this.parm_sel.length; i++) {
					let t = 0;
					t = i + 1 + '';
					switch (t) {
						case '1':
							this.kw1 = this.parm_sel[i].val;
							break;
						case '2':
							this.kw2 = this.parm_sel[i].val;
							break;
						case '3':
							this.kw3 = this.parm_sel[i].val;
							break;
						case '4':
							this.kw4 = this.parm_sel[i].val;
							break;
						case '5':
							this.kw5 = this.parm_sel[i].val;
							break;
						case '6':
							this.kw6 = this.parm_sel[i].val;
							break;
						case '7':
							this.kw7 = this.parm_sel[i].val;
							break;
						case '8':
							this.kw8 = this.parm_sel[i].val;
							break;
						case '9':
							this.kw9 = this.parm_sel[i].val;
							break;
					}
				}

				let that = this;
				let r = (Math.random() + '').substring(0, 8);
				setTimeout(function() {
					that.load_url = api.http_method;
					that.load_json = Sel_page_and_length(that.sel_action, that.nowpage, that.page_length, that
						.kw1,
						that
						.kw2, that.kw3, that.kw4, that.kw5, that.kw6, that.kw7, that.kw8, that.kw9, '', r);
				}, 200);
			},
			hide_edit_view: function() {
				this.$refs.file_table.hide();
			},
			refresh_data: function(type, page, pagelength, backdata) {
				console.log('查询刷新=' + type + ' page=' + page + ' pagelength=' + pagelength);
				// console.log(backdata);
				// PAGE_LENGTH_CHANGE 改变分页长度,刷新加载

				if (type == 'PAGE_LENGTH_CHANGE' || type=='PAGE_NOW' || typeof(type)==='undefined') {
					this.nowpage = page;
					this.page_length = pagelength;
					this.load_db_data();
					return;
				}

				if (type == 'IMAGE_LIST' && backdata.length > 0) {
					this.file_list_main = [];
					this.file_list_main = backdata;
					return;
				}
				// let r = (Math.random() + '').substring(0, 8);

				if (type == 'UPDATE_OK') {
					let back = null;
					if (typeof(backdata) != "undefined" && backdata != '') {
						back = JSON.parse(backdata);
						console.log(back);
						// console.log('new_id=' + back.new_id);
						this.row_id = back.new_id;
						this.sheet_flag = back.msg;
						// 同步关键参数便于后续修改
						this.sys_date = back.sys_date;
						this.sheet_no = back.sheet_no;
						for (let i = 0; i < this.parm.length; i++) {
							if (this.parm[i].key == 'sheet_no') {
								this.parm[i].val = this.sheet_no;
								break;
							}
						}

						this.element_loading = true;
						let r = (Math.random() + '').substring(0, 8);
						this.$post(
							api.http_method, Sel_page_and_length(this.sel_action, 1, 1, 'ID' + this.row_id, '', '',
								'',
								'', '', '',
								'', '', '', '', '', r)
						).then(res => {
							res = JSON.parse(res);

							this.element_loading = false;
							let res_page = [];
							res_page = res[0][0];

							if (res_page.flag == 1) {
								let bd = [];
								// console.log('allcount='+res_page.all_count)
								if (res_page.all_count > 0) {
									let t_list_data = res[1];
									// console.log(t_list_data);
									for (let i = 0; i < t_list_data.length; i++) {
										let arr = [];
										for (let j in t_list_data[i]) {
											let o = {};
											o.key = j;
											let temp_str = '';
											temp_str = t_list_data[i][j];
											if (typeof(temp_str) === 'string' && temp_str.indexOf("\\r\\n") >
												0) {
												temp_str = ReplaceAll(temp_str, '\r\n', "<br/>");
												temp_str = ReplaceAll(temp_str, '\n', "<br/>");
												temp_str = temp_str.replace("\\r\\n", "\r\n");
												temp_str = temp_str.replace("\\n", "\n");
											}
											o.val = temp_str;
											arr.push(o);
										}
										bd.push(arr);
									}
								}

								this.sel_row(bd[0], 'edit');

							} else {
								this.$message({
									message: '编辑数据更新失败! \r\n ' + res.data.msg,
									type: 'success'
								});
							}

						});

					}



				}


				//如果弹出编辑界面，有非编辑内容。应该查询一下，进行更新

			},
			sel_row: function(item, type) {
				console.log(item);
				console.log('type=' + type);
				// 判断 obj.hasOwnProperty("key")
				//2、遍历Json串获取其属性
				for (let i = 0; i < item.length; i++) {
					switch (item[i].key) {
						case 'id':
							this.row_id = item[i].val;
							break;
						case 'flag':
							this.sheet_flag = item[i].val;
							break;
						case 'sys_date':
							this.sys_date = item[i].val;
							break;
						case 'sheet_no':
							this.sheet_no = item[i].val;
							break;
						default:
							break;
					}
				}

				for (let i = 0; i < item.length; i++) {
					for (let j = 0; j < this.parm.length; j++) {
						if (this.parm[j].key == item[i].key) {
							if (this.parm[j].type == 'select' || this.parm[j].type == 'radio') {
								// console.log(this.parm[j]);
								this.parm[j].val = '';
								this.parm[j].sel_name = item[i].val;
							} else {
								this.parm[j].val = item[i].val;
							}

						}
					}
				}

				console.log(this.parm)
				switch (type) {
					case 'edit': // 切换背景色
						this.$refs.file_table.setCurrentRowJsonOld('m_', item[1].val);
						break;
					case 'show': // 打开编辑页面
						this.$refs.file_table.showpop();
						break;
					case 'del': // 执行删除
						this.fun_upd('_del');
						break;
					default:
						break;
				}
			},
			fun_upd: function(type) {
				// console.log('操作类型=' + type + ' row_id=' + this.row_id);
				if (type == '_upd') {
					if (this.row_id == 0) {
						this.$message({
							message: '请选择要修改的数据!',
							type: 'warning'
						});
						return;
					}
				}

				if (type == '_add') {
					let stop = false;
					let temp_name = '';
					for (let i = 0; i < this.parm.length; i++) {
						// console.log(this.parm[i]);
						if (this.parm[i].p == '1' && this.parm[i].w == '1' && this.parm[i].val == '') {
							stop = true;
							temp_name = this.parm[i].name;
							break;
						}
					}
					if (stop) {
						this.$message({
							message: temp_name + '不能为空!',
							type: 'warning'
						});
						return;
					}
				}

				let d = [];
				for (let i = 0; i < this.parm.length; i++) {
					// console.log(this.parm[i].val);
					if (this.parm[i].p == '1') {

						if (this.parm[i].type == 'time' || this.parm[i].type == 'datetime') {
							d.push(dateFormatbyChina(this.parm[i].val));
						} else if (this.parm[i].type == 'textarea') {
							// console.log(this.parm[i].val);
							let str = '';
							str = this.parm[i].val;
							// let str = this.parm[i].val;
							str = str.replace(/\n/g, '<br/>');
							str = str.replace(/\s/g, '&nbsp;');
							d.push(str);
						} else if (this.parm[i].type == 'select' || this.parm[i].type == 'radio') {
							console.log(this.parm[i]);
							if (this.parm[i].sel_name != '') {
								d.push(this.parm[i].sel_name);
							} else {
								d.push(this.parm[i].val);
							}



						} else {
							// console.log(this.parm[i].val);
							d.push(this.parm[i].val);
						}
					}
				}

				let r = (Math.random() + '').substring(0, 8);

				this.upd_json = Method_CommonLong('data' + this.upd_action + type, this.row_id, this.sys_date, d, r);


			},
			show_detaildata: function(that, item, type) {
				var x = 0,
					y = 0,
					temp_css = '';
				// console.log('明细数据显示坐标 ' + x + ' ' + y);
				// console.log(that);
				x = that.pageX + 10;
				y = that.pageY;

				var screenWidth = $(window).width();
				var screenHeight = $(window).height(); //当前浏览器窗口的 宽高
				// var scrolltop = $(document).scrollTop();//获取当前窗口距离页面顶部高度

				// console.log('页面宽度=' + screenWidth + '页面高度=' + screenHeight);
				// console.log('明细数据显示坐标 ' + x + ' ' + y);

				if ((x + 140) > screenWidth) {
					x = x - 160;
				}

				temp_css = "display: block;position: absolute;top:" + y + "px;left:" + x +
					"px;background-color: #99CCFF;border: 1px solid black;padding-left: 20px;padding-right: 20px;border-radius: 5px;z-index: 99999;";
				if (type == "0" && item.detail_data.length > 0) {
					this.detail_data = item.detail_data;
					// console.log($('#pre_detail_data'));
					document.getElementById("pre_detail_data").style.cssText = temp_css;
				}
				if (type == "1" && item != '') {
					temp_css += "max-width: 500px;word-break: break-all;padding-top: 5px;padding-bottom: 5px;";

					let temp_innerHtml = '';
					temp_innerHtml = BackSpecial(item);
					temp_innerHtml = temp_innerHtml.replace(/\r\n/g, "<br/>").replace(/\n/g, "<br/>")

					document.getElementById("pre_msg_data").innerHTML = temp_innerHtml;
					document.getElementById("pre_msg_data").style.cssText = temp_css;
				}
			},
			noshow_detaildata: function() {
				// console.log('不显示明细');
				document.getElementById("pre_detail_data").style.display = 'none';
				document.getElementById("pre_msg_data").style.display = 'none';
			},
			build_exceldata: function(type) {
				// 不做分页
				// 不做分页
				if (type == 'close') {
					this.show_excel = false;
				} else {
					for (let i = 0; i < this.parm_sel.length; i++) {
						switch (this.parm_sel[i].sel) {
							case '1':
								this.kw1 = this.parm_sel[i].val;

								break;
							case '2':
								this.kw2 = this.parm_sel[i].val;
								break;
							case '3':
								this.kw3 = this.parm_sel[i].val;
								if (this.parm_sel[i].type == 'datemonth') {
									this.kw3 = dateFormatbyChina(this.kw3);
								}
								break;
				  	case '4':
								this.kw4 = this.parm_sel[i].val;
								if (this.parm_sel[i].type == 'datemonth') {
									this.kw4 = dateFormatbyChina(this.kw4);
								}
								break;
							case '5':
								this.kw5 = this.parm_sel[i].val;
								break;
							case '6':
								this.kw6 = this.parm_sel[i].val;
								break;
							case '7':
								this.kw7 = this.parm_sel[i].val;
								break;
							case '8':
								this.kw8 = this.parm_sel[i].val;
								break;
							case '9':
								this.kw9 = this.parm_sel[i].val;
								break;
							case '10':
								this.kw10 = this.parm_sel[i].val;
								break;
						}
					}

					this.postjson1 = Object.assign({}, this.postjson1, {
						type: 'down1',
						url: api.http_method,
						post: Sel_page_and_length(this.sel_action, this.nowpage, this.page_length, this.kw1,
							this.kw2,
							this.kw3, this.kw4, this.kw5, this.kw6, this.kw7, this.kw8, this.kw9, this.kw10
							)
					});

					this.show_excel = true;
				}
			},

			//附件操作 start //////////////////////////////////////
			// 点击上传附件
			fun_look_file: async function(item) {
				console.log('点击预览附件');
				if (typeof(item) !== 'undefined' && item != '') {
					await this.sel_row(item);
				}

				if (this.file_url == null || String(this.file_url).length == 0 || String(this.file_url) == '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '操作不正确,已经上传附件<div class="mtop mdown" > 名称=' + this.file_name + '</div>请检查!'
					});
					return;
				}

				if (/\.(gif|jpg|jpeg|png|ico|pdf)$/.test(this.file_name.toLowerCase())) {
					// 会被火狐浏览器弹窗阻止,360和谷歌正常
					var pdfview = document.getElementById('loodlink');
					pdfview.href = this.file_url;
					// window.open(tv_url, '_blank'); //被弹窗阻止
					pdfview.click();

				} else {
					this.$message({
						message: '该类型文件暂不支持预览,将开始下载!',
						type: 'success'
					});

					let down_file = document.getElementById("downlink");
					let temp_url = BackSpecial(this.file_url);
					let temp_filename = BackSpecial(BackSpecial(temp_url.substring(temp_url.lastIndexOf('/') + 1)));
					down_file.download = this.file_name; // 下载名称
					down_file.href = temp_url; // 绑定a标签
					down_file.click(); // 模拟点击实现下载
				}
			},
			getFilePath: function() {
				let tmpFile = document.getElementById('savefile');
				// console.log('点击选择结果');
				// console.log(tmpFile.files);
				if (typeof FileReader !== "undefined") {
					let max_size = 5000; // 50k 20M
					let name = '';
					let size = 0;
					let fileData = tmpFile.files[0];

					this.file_backdata = fileData;
					name = fileData.name;
					size = fileData.size;
					this.file_size = size;

					// console.log('名称=' + name + ' 大小=' + size);
					if (!(/\.(gif|jpg|jpeg|png|ico|pdf)$/.test(name.toLowerCase()))) {
						this.$message({
							message: '只可以上传图片、pdf、doc、docx、zip、rar格式',
							type: 'warning'
						});
						return;
					}
					this.file_name = name;

					if (size > max_size * 1024) {
						this.$message({
							message: '图片大小不能超过5M',
							type: 'warning'
						});
						return
					}
					// console.log(tmpFile);   //连标签原样输出了
					// console.log(tmpFile.value);   //图片路径

					let reader = new FileReader(); // FileReader
					let that = this;
					reader.readAsDataURL(fileData);
					reader.onload = function() {
						// 获取到base64图片内容
						that.file_data = this.result;
					}
					// console.log(size / 1024 + 'kB');
				} else {
					this.$message({
						message: '当前浏览器不支持上传组件',
						type: 'warning'
					});
				}

			},

		}
	};
</script>


<style scoped>
	.td-image {
		cursor: pointer;
	}

	.pre-input {
		display: inline-block;
		vertical-align: middle;
		width: 128px;
	}
</style>
